import { render, staticRenderFns } from "./PropertySetupDistributionForm.vue?vue&type=template&id=0995c440&scoped=true&"
import script from "./PropertySetupDistributionForm.vue?vue&type=script&lang=js&"
export * from "./PropertySetupDistributionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0995c440",
  null
  
)

export default component.exports